/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IState, ILevelsLayout } from '../types/StateTypes';

import LevelsLayoutHelper from '../util/levelsLayoutHelper';

export default (state :IState): ILevelsLayout => {
    const {
        levelsLayout: {
            rows, columns
        }
    } = state;

    return {
        rows: LevelsLayoutHelper.transformMeasuresLevelLayout(rows, columns),
        columns: LevelsLayoutHelper.transformMeasuresLevelLayout(columns),
    }
}
